export const linkParametrizedKey = '#href';
export const linkSplitRegex = new RegExp(`(\\${linkParametrizedKey}[0-9])`, 'g');
